/* eslint-disable no-use-before-define */
import React from 'react'
import { getId, Flyout, } from '../../twd'

export const InputCusip = ({cusip, setCusip, isError, onEnter}) => {

    const id = getId()
    const [el, setEl] = React.useState(null)
    React.useEffect(() => {
        if (!el) return
        setTimeout(() => el.focus(), 100)
    }, [el])

    return <React.Fragment>
        <div className="vertical-offset-base">
        <div><Flyout
            label="CUSIP"
            labelAttrs={{htmlFor:id, className:'label'}}
            html={CusipTooltip}
            labelStyle={{ lineHeight:'20px', display:'inline' }}
            isLabel={true}
        /></div>

        <div className={(isError ? ' has-error': '')}>
        <div className='vertical-offset-xxs'>
            <input
                ref={setEl}
                className="form-control focus-on-load"
                type="text"
                id={id}
                value={cusip}
                {...(isError ? {"aria-invalid":true} : {})}
                onChange={(e) => {
                    setCusip(e.target.value)
                }}
                onKeyUp={(e) => {
                    let key = e.keyCode || e.key || e.which
                    if (!(key===13 || key === 'Enter')) return

                    e.preventDefault()
                    onEnter(e.target.value)
                }}
            />
        </div>
        { isError && <label className="field-status has-error" style={{textAlign:'left'}}>Please enter a valid CUSIP</label> }
        </div>
        </div>
    </React.Fragment>
}

const CusipTooltip = `
<p>CUSIP stands for Committee on Uniform Securities Identification Procedures. When issued, each bond is assigned a CUSIP number, comprised of nine alphanumeric characters to uniquely identify the security.</p>
`


// WEBPACK FOOTER //
// ./src/calculator/cusip-input/input-cusip.js